import { render, staticRenderFns } from "./HorizontalScrollContainer.vue?vue&type=template&id=36f02928&"
import script from "./HorizontalScrollContainer.vue?vue&type=script&lang=js&"
export * from "./HorizontalScrollContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports